/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_CoffeeInputs */

const en_tab_coffee = /** @type {(inputs: Tab_CoffeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coffee`)
};

const es_tab_coffee = /** @type {(inputs: Tab_CoffeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cafe`)
};

/**
* | output |
* | --- |
* | "Coffee" |
*
* @param {Tab_CoffeeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tab_coffee = /** @type {((inputs?: Tab_CoffeeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_CoffeeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tab_coffee(inputs)
	return es_tab_coffee(inputs)
});